import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { customerMemory } from "../../../Objects/Memory/Memory"
import { useGetCustomer } from "../../../hooks/Costumer/useGetCustomer"
import { CustomerPopup } from "./CustomerPopup"
import { CustomerEntity } from "../../../Objects/Customer/CustomerEntity"
import { ECustomerPaymentType } from "../../../Enum/ECustomerPaymentType"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const CustomerPage: React.FC = () => {
  const { t } = useTranslation("customer")

  const [enableClients, setEnableClients] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const { handleGetCostumer } = useGetCustomer()

  const [costumerSelected, setCostumerSelected] = useState<CustomerEntity | undefined>(undefined)

  useEffect(() => {
    handleGetCostumer(() => {})
  }, [])

  const handleOpenEditePromotion = (id: number) => {
    const costumerTemp = customerMemory.findById(id)!

    if (costumerTemp.isDefaultCustomer) {
      return
    }

    handleSwitchEditeOrAdd(true)

    setCostumerSelected(costumerTemp)
  }

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setCostumerSelected(undefined)

    setEnableClients(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          messageCount={t("list:label_customer_page_message_count")}
          messageEmpty={t("list:label_customer_page_message_empty")}
          nameFindSearch={t("list:label_customer_page_place_holder")}
          data={customerMemory.getListCards(true)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
          handleRefreshButton={() => handleGetCostumer(() => {})}
          defaultStatusFilter={ECustomerPaymentType.All.toCustomerPaymentTypeString()}
          nameDropdown={[
            ECustomerPaymentType.WithOutDebit.toCustomerPaymentTypeString(),
            ECustomerPaymentType.WithInDebit.toCustomerPaymentTypeString(),
            ECustomerPaymentType.All.toCustomerPaymentTypeString(),
          ]}
        />
      </div>

      {enableClients && (
        <CustomerPopup
          costumer={costumerSelected}
          title={
            costumerSelected && costumerSelected.id !== -1 ? t("title_customer_edite") : t("title_customer_create")
          }
          onClonse={() => handleSwitchEditeOrAdd(false)}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="clientes"
          title={t("dataImport:title", { target: t("dataImport:target_customers") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetCostumer(() => {})}
        />
      )}
    </>
  )
}
